import React from 'react';
import styled from '@nykaa/ui-components/styles/styled';
import _ from 'lodash';
import { PopularSuggestion, PopularSuggestionType } from 'types/searchSuggestion';
import Chips from '@nykaa/ui-components/Chips';
import { CHIPS_IN_SINGLE_ROW } from 'constants/searchSuggestion';


const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.surface};
  padding-bottom: ${({ theme }) => theme.spacing.spacing60};
`;

const Wrapper = styled.div`
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  overflow: auto;
`;

const Title = styled.h4`
  ${({ theme }) => theme.typography.subTitleMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
  padding: ${({ theme }) => theme.spacing.spacing80};
`;

const Flex = styled.div`
  display: flex;
  width: fit-content;
  align-items: center;
  padding: 0px ${({ theme }) => theme.spacing.spacing60};
`;

const ChipWrapper = styled.div`
  margin: 4px;
  & button {
    width: max-content
  }
`;
interface SuggestionsChips {
    popularSuggestionType: PopularSuggestionType,
    handleClick: (suggestion: PopularSuggestion, position: number) => void
}

function SuggestionsChip({ popularSuggestionType, handleClick }: SuggestionsChips) {
    const {
      suggestions,
      q:title,
      id,
    } = popularSuggestionType;
    if (suggestions?.length < 1) {
        return null;
    }

    const splitSuggestionsInRows = () => {
      if (suggestions?.length > CHIPS_IN_SINGLE_ROW) {
        const suggestionRow: PopularSuggestion[][] = [[], []];
        suggestions.forEach((suggestion, index) => {
          (index % 2 === 0) ? suggestionRow[0].push(suggestion) : suggestionRow[1].push(suggestion);
        });
        return suggestionRow;
      }
      return [suggestions];
    };

    const splitSuggestions = splitSuggestionsInRows() || [];
    return (
      <Container>
        <Title>{_.startCase(_.lowerCase(title))}</Title>
        <Wrapper>
          {
            splitSuggestions.map((suggestionsArray, index) => <Flex key={`${id}-${index}`}>
              {
                suggestionsArray?.map((suggestion, suggestionIndex) => <ChipWrapper key={suggestionIndex}>
                  <Chips
                    label={suggestion.q}
                    size="small"
                    onClick={() => handleClick(suggestion, index * suggestionsArray.length + suggestionIndex + 1)}
                  />
                </ChipWrapper>)
              }
            </Flex>
            )
          }
        </Wrapper>
      </Container>
    );
}

export default SuggestionsChip;
